/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountTagKeyValueQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountTagKeyValueQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountTagKeyValueQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountTagKeyValueQueryOperator>): ServiceAccountTagKeyValueQueryOperator {
        let obj = Object.assign(new ServiceAccountTagKeyValueQueryOperator(), model);
        ServiceAccountTagKeyValueQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountTagKeyValueQueryOperator>): ServiceAccountTagKeyValueQueryOperator {
        if (!model) return null;
        return ServiceAccountTagKeyValueQueryOperator.newInstance(<ServiceAccountTagKeyValueQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountTagKeyValueQueryOperator) {
        if (!obj) return;

        models.ServiceAccountTagKeyValueQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountTagKeyValueQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountTagKeyValueQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tag key for the given cloud account
     */
    tag_key: string;

    /**
     * Tag values for the given key
     */
    tag_values: Array<string>;

}
